module.exports = __webpack_public_path__ + "img/ggA_Hallertau.9a59525f.png";